import {
    QueryClient,
    VueQueryPlugin,
} from '@tanstack/vue-query';

/**
 * Tanstack Query plugin
 * --------------------------------------------------------------------------------------------------
 */
export default defineNuxtPlugin((nuxt) => {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                // retry: 0,
                // staleTime: 0
            },
        },
    });

    nuxt.vueApp.use(VueQueryPlugin, {
        queryClient,
        enableDevtoolsV6Plugin: true,
    });
});
